<template>
  <div class="teach-assistant">
    <div class="h3">助教答疑</div>
    <div class="content">领取教学资源、课程咨询、产品使用等相关疑问，随时与助教联系，我们将竭诚为您服务！</div>
    <div class="copy-qq">
      助教QQ号：<br>{{qq}}
      <a v-clipboard:copy="qq" v-clipboard:success="onCopy">复制</a>
    </div>
    <div class="wechat">助教微信号：abc_jinshanshan</div>
    <div class="qrcode">
      <img src="../assets/wechat_qrcode.png" alt>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TeachingAssistantInfo',
  data () {
    return {
      qq: '2868967082'
    }
  },
  methods: {
    onCopy () {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
.teach-assistant {
  width: 220px;
  height: 532px;
  background: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
}
.h3 {
  border-left: 3px solid #FE793A;
  padding-left: 8px;
  line-height: 1.2;
  margin: 0;
  font-size: 16px;
}
.content {
  margin-top: 20px;
  text-align: justify;
}
.copy-qq {
  margin-top: 20px;
}
.copy-qq a {
  margin-left: 20px;
  color: #FE793A;
  cursor: pointer;
}
.wechat {
  margin-top: 20px;
}
.qrcode {
  margin-top: 20px;
  text-align: center;
}
</style>
